import axios from 'axios';
import { getToken, getBaseUrl } from 'utils';
import { getOrganization } from 'utils/organizationUtils';
const arrayPathsInvalidRedirect = ['/login', `/${getOrganization()}/login/user`, `/${getOrganization()}/login`];
const instance = axios.create({
  baseURL: getBaseUrl(),

  headers: {
    Accept: 'application/json',
    crossDomain: true,
    'Access-Control-Allow-Origin': '*',
    'Access-Control-Allow-Methods': 'GET,PUT,POST,DELETE,PATCH,OPTIONS',
    'Access-Control-Allow-Headers':
      'Origin, Accept, X-Requested-With, Content-Type, Access-Control-Request-Method, Access-Control-Request-Headers',
    'Content-Type': 'application/json,multipart/form-data,text/csv',
    // 'Access-Control-Request-Headers':  'Origin, Accept, X-Requested-With, Content-Type, Access-Control-Request-Method, Access-Control-Request-Headers'
  },
  validateStatus: (status): boolean => {
    return status >= 200 && status < 300; // default
  },
});

instance.interceptors.request.use(
  (config) => {
    config.headers.Authorization = getToken();
    config.headers.fqdn = getOrganization();
    return config;
  },
  (error) => {
    // Do something with request error
    return Promise.reject(error);
  }
);
// instance.interceptors.request.use(
//   (config) => {
//     config.headers.Authorization = getToken();
//     const pathName = window.location.pathname;
//     if (!arrayPathsInvalidRedirect.includes(pathName)) {
//       config.headers.fqdn = getOrganization();
//     } else {
//       config.headers.fqdn = 'login';
//     }
//     return config;
//   },
//   (error) => {
//     // Do something with request error
//     return Promise.reject(error);
//   }
// );

// instance.interceptors.response.use(
//   (response) => {
//     return response;
//   },
//   (error) => {
//     if (
//       error.response &&
//       error.response.status === 401 &&
//       !arrayPathsInvalidRedirect.includes(window.location.pathname)
//     ) {
//       setTimeout(() => {
//         if (error.config?.headers?.fqdn) {
//           let fqdn = error.config.headers.fqdn;
//           if (fqdn.endsWith('/login')) {
//             fqdn = fqdn.replace(/\/login$/, '');
//           }
//           const newPath = `/${fqdn}/login/admin`;
//           if (window.location.pathname !== newPath) {
//             window.location.href = newPath;
//           }
//         } else {
//           if (window.location.pathname !== '/login/admin') {
//             window.location.href = '/login/admin';
//           }
//         }
//       }, 2000);
//     }
//     return Promise.reject(error);
//   }
// );

instance.interceptors.response.use(
  (response) => {
    return response;
  },
  (error) => {
    if (
      error.response &&
      error.response.status === 401 &&
      !arrayPathsInvalidRedirect.includes(window.location.pathname)
    ) {
      const isLocal = process.env.REACT_APP_LOCAL === 'local' || window.location.hostname === 'localhost';

      if (isLocal) {
        window.location.href = `/login`;
      } else {
        const protocol = window.location.protocol;
        const hostname = window.location.hostname;
        window.location.href = `${protocol}//${hostname}/login`;
      }
    }
    return Promise.reject(error);
  }
);

export default instance;
